import React from 'react';
import type { IconProps } from '../types';

export const IconPuzzle: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M8 6.5C8 5.11929 6.88071 4 5.5 4C4.11929 4 3 5.11929 3 6.5V8.5H4.5C5.32843 8.5 6 9.17157 6 10C6 10.8284 5.32843 11.5 4.5 11.5H3V13.5C3 14.8807 4.11929 16 5.5 16H7.5V14.5C7.5 13.6716 8.17157 13 9 13C9.82843 13 10.5 13.6716 10.5 14.5V16H12.5C13.8807 16 15 14.8807 15 13.5V11.5H13.5C12.6716 11.5 12 10.8284 12 10C12 9.17157 12.6716 8.5 13.5 8.5H15V6.5C15 5.11929 13.8807 4 12.5 4H10.5V5.5C10.5 6.32843 9.82843 7 9 7C8.17157 7 7.5 6.32843 7.5 5.5V4H5.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

